<div class="container mt-3 mx-auto">
    <div class="alert alert-info" *ngIf="!associados || !associados.length">
        Não foram encontradas associações para os filtros informados.
    </div>

    <div class="row" *ngIf="associados && associados.length">
        <div>
            <button class="btn btn-secondary float-end" type="button" (click)="bntExportarAssociados()"
              placement="top" ngbTooltip="Exporta todos os SCR's Associados listados">
              <i class="fa fa-file"></i> Exportar Associados</button>
        </div>
    
        <bn-paginacao [total]="atributosPaginacao.count" [tamanhoPagina]="atributosPaginacao.pageSize"
            [numPagina]="atributosPaginacao.page" [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th  class="col-2" id="col-cnpj-agente-financeiro" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'CNPJ'"
                                    [nomeAtributoExibicao]="'CNPJ'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th  class="col-1" id="col-sigla-agente-financeiro" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'sigla'"
                                    [nomeAtributoExibicao]="'Sigla'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th  class="col-2" id="col-nome-agente-financeiro" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'agenteFinanceiro'"
                                    [nomeAtributoExibicao]="'Nome Agente Financeiro'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                    
                            <th  class="col-2" id="col-cnpj-associado" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'cnpjAssociado'"
                                    [nomeAtributoExibicao]="'CNPJ Associado'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th class="col-5" id="col-nome-cnpj-associado" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'nomeRazaoSocialAssociado'"
                                    [nomeAtributoExibicao]="'Nome Agente Associado'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let associado of associados">
                            <td>{{ retornaCnpjPorIdAssociado(associado.agenteFinanceiro) | bnMask: 'CNPJ'}}</td>
                            <td>{{ retornaSiglaPorIdAgente(associado.agenteFinanceiro) }}</td>
                            <td>{{ nomeAgenteFinanceiroPorId(associado.agenteFinanceiro) }}</td>
                            <td>{{ associado.cnpjAssociado | bnMask:'CNPJ' }}</td>
                            <td>{{ nomeReduzido(associado.nomeRazaoSocialAssociado) }}</td>
                            <td *ngIf="podeEnviarScr" class="text-start" id=col-acoes>
                                <a href="javascript:void(0)" (click)="excluirAssociado(associado.id)">
                                  <i class="fa fa-trash cursor-pointer margin-left-5" placement="left-top" ngbTooltip="Excluir Associado"></i>
                                </a>
                              </td>
                            
                        </tr>
                    </tbody>
                </table>
            </div>
        </bn-paginacao>
    </div>
</div>